export const balancesKeys = {
  base: ["balances"],
  byAddress: (address?: string, parameters?: Record<string, number | string | undefined>) => [
    ...balancesKeys.base,
    address,
    parameters,
  ],
};
